import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

const Label = styled.span``;

const LocationName = styled.span`
  color: #333;
  font-weight: bold;
`;

const Wrapper = styled.div`
  margin: 0;
  padding: 5px;
  background-color: #f0f6eb;
  display: flex;
  box-sizing: border-box;

  .dc-link {
    font-size: 13px;
  }

  .dc-link.disabled {
    cursor: default;
    color: #a9a9a9;
  }

  ${({ orientation }) =>
    (orientation === 'horizontal'
      ? css`
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;

          ${LocationName} {
            margin: 0 10px 0 5px;
          }

          a.dc-link {
            border-left: 1px solid #d8d8d8;
            padding: 7px 0 7px 10px;
          }
        `
      : css`
          flex-direction: column;
          justify-content: flex-start;

          ${Label} {
            font-size: 14px;
            margin-top: 5px;
          }

          ${LocationName} {
            font-size: 13px;
            margin: 5px 0;
          }

          .dc-link {
            margin-bottom: 5px;
            padding: 0;
          }
        `)}
`;

export default function LocationFoundBlock(props) {
  return (
    <Wrapper orientation={props.orientation}>
      <Label>{props.locationFoundLabel}</Label>
      <LocationName>{` ${props.locationName} `}</LocationName>
      <a
        className={props.linkDisabled ? 'dc-link disabled' : 'dc-link'}
        href={'#change-location'}
        onClick={(e) => {
          e.preventDefault();
          if (props.linkDisabled) {
            e.stopPropagation();
          } else {
            props.onLinkClick(e);
          }
        }}
      >
        {props.linkLabel}
      </a>
    </Wrapper>
  );
}

LocationFoundBlock.propTypes = {
  locationFoundLabel: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  linkDisabled: PropTypes.bool.isRequired,
  onLinkClick: PropTypes.func.isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
};

LocationFoundBlock.defaultProps = {
  orientation: 'horizontal'
};
